module.exports = __webpack_public_path__ + "static/media/homeTabUnselected.502e4d21.png";